module.exports = __webpack_public_path__ + "media/images/demo/cart2-a2c43941746c91cd4f740945c0ff877a.png";